import React from "react";
import starIcon from "../../assets/images/star-icon.png";
import process1 from "../../assets/images/process/process1.png";
import process2 from "../../assets/images/process/process2.png";
import process3 from "../../assets/images/process/process3.png";
import { useTranslation } from "gatsby-plugin-react-i18next";

const B = () => {
	const { t } = useTranslation();

	return (
		<section className="process-area pt-100 pb-70">
			<div className="container">
				<div className="section-title">
					<span className="sub-title">
						<img src={starIcon} alt="banner" />
						{t("home.Bp")}
					</span>
					<h2>{t("home.Bh2")}</h2>
					<p>{t("home.Bp1")}</p>
				</div>

				<div className="row">
					<div className="col-lg-4 col-md-6">
						<div className="single-process-box">
							<div className="number">1</div>
							<div className="image">
								<img src={process1} alt="banner" />
							</div>
							<h3>{t("home.Bh31")}</h3>
							<p>{t("home.Bp2")}</p>
						</div>
					</div>

					<div className="col-lg-4 col-md-6">
						<div className="single-process-box">
							<div className="number">2</div>
							<div className="image">
								<img src={process2} alt="banner" />
							</div>
							<h3>{t("home.Bh32")}</h3>
							<p>{t("home.Bp3")}</p>
						</div>
					</div>

					<div className="col-lg-4 col-md-6">
						<div className="single-process-box">
							<div className="number">3</div>
							<div className="image">
								<img src={process3} alt="banner" />
							</div>
							<h3>{t("home.Bh33")}</h3>
							<p>{t("home.Bp4")}</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default B;
